import { defaults } from 'lodash';
import {
  APPS_MIN_WIDTH,
  APPS_MAX_WIDTH,
  APPS_MIN_HEIGHT,
  APPS_MAX_HEIGHT,
  VIDEO_DEFAULT_HEIGHT,
  VIDEO_DEFAULT_WIDTH,
} from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class VideoConfigurations extends BoardItemConfig {
  url?: string;
  title: string;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    width: VIDEO_DEFAULT_WIDTH,
    height: VIDEO_DEFAULT_HEIGHT,
    minWidth: APPS_MIN_WIDTH,
    maxWidth: APPS_MAX_WIDTH,
    minHeight: APPS_MIN_HEIGHT,
    maxHeight: APPS_MAX_HEIGHT,
  };

  constructor(
    configurations: Partial<VideoConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...VideoConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const defaultVideoConfigurations = {
      title: 'Video',
    };

    const videoConfigurations = defaults(configurations, defaultVideoConfigurations);

    this.url = videoConfigurations.url;
    this.title = videoConfigurations.title;
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): VideoConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      VideoConfigurations.defaultBoardItemConfigurations,
    );

    return new VideoConfigurations(
      {
        ...configurations,
        url: frameItem.resource_state?.resource_url,
        title: frameItem.resource_state?.resource_name,
      },
      globalCreationsParams,
    );
  }
}
